export enum Roles {
  SuperUser = "superuser", //1
  Admin = "admin", //2
  CustomerService = "customer service",
  SalesRep = "rep", //3
  SalesManager = "sales manager", //4
  Customer = "customer", // retail salesperson, contract salesperson, & designer
  Unverified = "unverified" // random members of the public who create an account to play with shade designer? Is there a better name?
}
